<h1 style="text-align: center; font-weight: bold">
  <span>{{ "OHS_PLAN" | translate }} </span>
</h1>
<div *ngIf="!loading">
  <div class="table-view mbtm-30">
    <div style="padding-bottom: 15px; text-align: right">
      <button type="button" *ngIf="isShowOHSPlanTable && canEdit" class="btn btn-primary"
        (click)="AddDefaultTemplate()">
        <span translate>IMPORT_FROM_TEMPLATE</span>
      </button>
    </div>
    <table class="table table-striped table-bordered form-table" *ngIf="isShowOHSPlanTable">
      <thead>
        <tr>
          <th colspan="1" style="width: 10%">
            <span translate>PERFORMED_BY</span>
            <span class="required">*</span>
            <input type="text" class="form-control input-sm" [readonly]="!canEdit"
              [(ngModel)]="OHS_PerfomedDetails.PerformedBy" />
          </th>
          <th colspan="4">
            <span colspan="1" translate>PERIOD_FROM</span>
            <span class="required">*</span>
            <p-datepicker name="PeriodFrom" [disabled]="!canEdit" [(ngModel)]="OHS_PerfomedDetails.PeriodFrom"
              [showIcon]="true" [dateFormat]="'dd/mm/yy'" [maxDate]="maxFromDate" (onSelect)="FromDateChanged($event)">
            </p-datepicker>
          </th>
          <th colspan="4">
            <span colspan="1" translate>PERIOD_TO</span>
            <span class="required">*</span>
            <p-datepicker name="PeriodTo" [disabled]="!canEdit" [(ngModel)]="OHS_PerfomedDetails.PeriodTo"
              [showIcon]="true" [dateFormat]="'dd/mm/yy'" [minDate]="minToDate" (onSelect)="ToDateChanged($event)">
            </p-datepicker>
          </th>
        </tr>
        <tr>
          <th translate>OHS-NO</th>
          <th translate>
            ACTIVITIES
            <span class="required">*</span>
          </th>
          <th translate>COMMENT</th>
          <th translate style="width: 8%">OHS-ADVISE</th>
          <th translate style="width: 8%">OHS-NOT-ADVISE</th>
          <th translate>INITIATOR</th>
          <th translate style="width: 10.5%">
            DEADLINE
            <span class="required">*</span>
          </th>
          <th translate *ngIf="canEdit">ACTIONS</th>
        </tr>
      </thead>
      <ng-template ngFor let-activity let-index="index" [ngForOf]="OHS_PerfomedDetails.OHS_Activity">
        <tbody>
          <tr>
            <td>
              <input type="text" readonly class="form-control input-sm" [(ngModel)]="activity.No" />
            </td>
            <td>
              <textarea pTextarea [readonly]="!canEdit" autoResize="autoResize" pTooltip="{{ activity.Activity }}"
                tooltipPosition="top" [(ngModel)]="activity.Activity"></textarea>
            </td>
            <td>
              <textarea pTextarea [readonly]="!canEdit" autoResize="autoResize" pTooltip="{{ activity.Comment }}"
                tooltipPosition="top" [(ngModel)]="activity.Comment"></textarea>
            </td>
            <td>
              <div style="display: flex; justify-content: center">
                <input type="checkbox" [disabled]="!canEdit" [(ngModel)]="activity.OHS_Advise" value="true"
                  (change)="selectOption('OHS_Advise', index)" />
              </div>
            </td>
            <td>
              <div style="display: flex; justify-content: center">
                <input type="checkbox" [disabled]="!canEdit" [(ngModel)]="activity.OHS_Not_Advise" value="false"
                  (change)="selectOption('OHS_Not_Advise', index)" />
              </div>
            </td>
            <td>
              <p-select [options]="initiator" [readonly]="!canEdit" [(ngModel)]="activity.Initiator">
              </p-select>
            </td>
            <td>
              <p-datepicker [disabled]="!canEdit" name="EventDate" [(ngModel)]="activity.Deadline" [showIcon]="true"
                [dateFormat]="'dd/mm/yy'" (onSelect)="dateChanged($event, index)">
              </p-datepicker>
            </td>
            <td>
              <div style="display: flex; justify-content: center; gap: 5px;">
                <button type="button" *ngIf="canEdit"  (click)="removeOhsActivity(index)" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                <button *ngIf="canEdit" type="button"  (click)="addNewRow(index)" class="kuba-icon-btn kuba-icon-btn--primary kuba-icon-btn--row">
            <i class="pi pi-plus"></i>
          </button>
              </div>
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>
  <div class="comment-section" style="margin-bottom: 20px;">
    <h3 style="font-weight: bold; margin-bottom: 10px;">{{ 'COMMENT' | translate }}</h3>
    <textarea pTextarea [(ngModel)]="tabz.text" [readonly]="!canEdit" rows="5"
      style="width: 100%; resize: vertical;"></textarea>
  </div>
  <div style="padding-top: 10px; float: right">
    <button translate class="btn btn-primary" *ngIf="canEdit" [disabled]="
        OHS_PerfomedDetails.PeriodFrom == null ||
        OHS_PerfomedDetails.PeriodTo == null ||
        OHS_PerfomedDetails.PerformedBy == null ||
        !checkActivityDeadline()
      " (click)="saveContent()">
      SAVE_LATER
    </button>
    <button translate class="btn btn-primary" [disabled]="
        !canEdit ||
        OHS_PerfomedDetails.PeriodFrom == null ||
        OHS_PerfomedDetails.PeriodTo == null ||
        OHS_PerfomedDetails.PerformedBy == null ||
        !checkActivityDeadline()
      " (click)="PrintOhs()">
      PDF
    </button>
    <button translate class="btn btn-primary" *ngIf="canEdit" [disabled]="
        OHS_PerfomedDetails.PeriodFrom == null ||
        OHS_PerfomedDetails.PeriodTo == null ||
        OHS_PerfomedDetails.PerformedBy == null ||
        !checkActivityDeadline()
      " (click)="ArchiveAndReset()">
      SAVE_PDF_IN_DOCUMENTS
    </button>
  </div>
</div>
<p-confirmDialog header="{{ 'CONFIRMATION' | translate }}" icon="pi pi-question-circle" width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}" rejectLabel="{{ 'SWITCH_NO' | translate }}"></p-confirmDialog>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>

